<template>
  <div class="toolbar-position-setting">
    <h2>位置</h2>
    <div class="options-container">
      <div
        v-for="positionData in positions"
        :key="positionData.name"
        class="option-card"
      >
        <div class="option-title">{{ positionData.title }}</div>
        <div
          :class="[
            { 'is-selected': toolbarPosition === positionData.name },
            'preview',
            `${positionData.name}-preview`,
          ]"
          @click="selectPosition(positionData.name)"
        >
          <img
            :src="positionData.previewImage"
            :alt="positionData.altText"
            class="preview-image"
          />
          <img
            v-if="toolbarPosition === positionData.name"
            src="@saas/pages/assets/images/live/live-set/selected.png"
            alt="已选中"
            class="selected-icon"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
export default {
  name: "ToolbarPositionSetting",
  data() {
    return {
      positions: [
        {
          name: "left",
          title: "居左显示",
          previewImage: require("@saas/pages/assets/images/live/live-set/toolbar-left.png"),
          altText: "居左显示预览",
        },
        {
          name: "right",
          title: "居右显示",
          previewImage: require("@saas/pages/assets/images/live/live-set/toolbar-right.png"),
          altText: "居右显示预览",
        },
      ],
    };
  },
  methods: {
    ...mapMutations("live", ["setToolbarPosition"]),
    selectPosition(position) {
      this.setToolbarPosition(position);
    },
  },
  computed: {
    ...mapState("live", ["toolbarPosition"]),
  },
};
</script>

<style scoped lang="scss">
$dark-text: #ecedee;
$border-color: #27272a;
$selected-border-color: #165dff;
$card-bg: #1f1f21; // Slightly lighter dark background for cards
$preview-bg: #e0e0e0; // Light background for preview areas

.toolbar-position-setting {
  h2 {
    font-weight: 500;
    font-size: 14px;
    color: #ecedee;
    line-height: 20px;
    margin-bottom: 18px;
  }

  .options-container {
    display: flex;
    gap: 18px;
  }

  .option-card {
    flex: 1;
    .option-title {
      font-weight: 500;
      font-size: 14px;
      color: #ecedee;
      line-height: 20px;
      margin-bottom: 8px;
    }

    .preview {
      width: 100%;
      height: 116px;
      cursor: pointer;
      position: relative;
      border-radius: 12px;
      border: 2px solid #000000;
      overflow: hidden;
      display: flex;
      align-items: center;
      .preview-image {
        width: 100%;
        height: 112px;
        object-fit: cover;
      }
      .selected-icon {
        position: absolute;
        top: 6px;
        right: 6px;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: none;
        object-fit: contain;
      }
      &.is-selected {
        border-color: #165dff;
      }
    }
  }
}
</style>
